// require("dotenv").config();
import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ProductDetail.css"; // Ensure your CSS styles are set up
import { FaDownload } from "react-icons/fa";

const ProductDetail = () => {
  const visualAidRef = useRef(null); // Add a ref to your visual aid image

  const location = useLocation();
  const navigate = useNavigate();
  const { product } = location.state || {}; // Fallback to an empty object if state is undefined

  const [isZoomed, setIsZoomed] = useState(false);

  // Function to handle image download
  const downloadImage = (imagePath, imageName) => {
    // Create an <a> element
    const link = document.createElement("a");
    link.href = imagePath;
    link.download = imageName; // Define the name of the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Updated useEffect hook to handle clicks outside the visual aid image
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isZoomed &&
        visualAidRef.current &&
        !visualAidRef.current.contains(event.target)
      ) {
        setIsZoomed(false); // Zoom out if click is outside the visual aid image
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("click", handleClickOutside);

    // Cleanup the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isZoomed]);

  // Function to toggle zoom
  const toggleZoom = () => setIsZoomed(!isZoomed);

  console.log(product);

  const getImagePath = (company, imageName) => {
    // Base URL for images in production - adjust the domain as necessary
    let basePath = "";

    // Determine the base path based on the company
    switch (company) {
      case "Trumac":
        basePath = "/app_admin/assets/images/products";
        break;
      case "Camrut":
        basePath = "/camrut_app_admin/assets/images/products";
        break;
      case "Medisync":
        basePath = "/medisync_app_admin/assets/images/products";
        break;
      case "Cialto Drugs":
        basePath = "/cialto_app_admin/assets/images/products";
        break;
      case "Pythus Pharma":
        basePath = "/pythus_app_admin/assets/images/products";
        break;
      default:
        basePath = "/images"; // Default path for development or fallback
    }

    // Check if the environment is development or production
    // This is a basic check, you might need to adjust it based on your setup
    const isDevelopment =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    // Return the correct path
    return isDevelopment
      ? `${process.env.PUBLIC_URL}/images/${imageName}`
      : `${basePath}/${imageName}`;
  };

  const getVisualPath = (company, imageName) => {
    // Base URL for images in production - adjust the domain as necessary
    let basePath = "";

    // Determine the base path based on the company
    switch (company) {
      case "Trumac":
        basePath = "/app_admin/assets/images/visualaid";
        break;
      case "Camrut":
        basePath = "/camrut_app_admin/assets/images/visualaid";
        break;
      case "Medisync":
        basePath = "/medisync_app_admin/assets/images/visualaid";
        break;
      case "Cialto Drugs":
        basePath = "/cialto_app_admin/assets/images/visualaid";
        break;
      case "Pythus Pharma":
        basePath = "/pythus_app_admin/assets/images/visualaid";
        break;
      default:
        basePath = "/images"; // Default path for development or fallback
    }

    // Check if the environment is development or production
    // This is a basic check, you might need to adjust it based on your setup
    const isDevelopment =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    // Return the correct path
    return isDevelopment
      ? `${process.env.PUBLIC_URL}/images/${imageName}`
      : `${basePath}/${imageName}`;
  };

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className="detail-page-wrapper">
      <button className="back-button" onClick={() => navigate(-1)}>
        Back
      </button>
      <div className="product-detail-container">
        <div className="product-image">
          <img
            src={getImagePath(product.company, product.product_image)}
            alt={product.brand_name}
          />
          <div
            className="download-icon"
            onClick={() =>
              downloadImage(
                getImagePath(product.company, product.product_image),
                product.product_image
              )
            }
          >
            <FaDownload />
          </div>
        </div>
        <div className="product-info">
          <h2>{product.brand_name}</h2>
          <p>{product.compostion}</p>
          <p>
            <strong>Packing:</strong> {product.packing}
          </p>
          <p>
            <strong>MRP:</strong> ₹{product.mrp}/- per {product.unit}
          </p>
          <p>
            <strong>Category:</strong> {product.category}
          </p>
          <p>
            <strong>Company:</strong> {product.company}
          </p>
          <p>
            <strong>Indications:</strong> {product.description}
          </p>
        </div>
        <div className="visual-aid">
          {product.visual_aid && (
            <>
              <h3>Visual Aid</h3>
              <div
                className="visual-aid-container"
                onClick={toggleZoom}
                ref={visualAidRef}
              >
                <img
                  src={getVisualPath(product.company, product.visual_aid)}
                  alt="Visual Aid"
                  className={`visual-aid-img ${isZoomed ? "zoomed" : ""}`}
                />
                <div
                  className="download-icon"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent zoom toggle when clicking on the download icon
                    downloadImage(
                      getVisualPath(product.company, product.visual_aid),
                      product.visual_aid
                    );
                  }}
                >
                  <FaDownload />
                  {/* Font Awesome Download Icon */}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
